import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'

import dataReducer from './reducers/dataReducer'
import clienteReducer from './reducers/clienteReducer'

const initialState = {}

const middleware = [
    thunk
]

const reducers = combineReducers({
    qr: dataReducer,
    data: clienteReducer
})

const store = createStore(
    reducers,
    initialState,
    compose(
        applyMiddleware(...middleware),
        window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
    )
)

export default store